import { useEffect, useRef } from 'react';
export function useResizeObserver(callback, options) {
    const ref = useRef(null);
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) {
                callback(entry);
            }
        });
        observer.observe(element, options);
        return () => {
            observer.disconnect();
        };
    }, [callback, options]);
    return ref;
}
